import pageNameMap from "./../pageNameMap.json"

export default function ReturnPageName(url) {
    if (!url) return "不明なページ";
    const pageName = pageNameMap[url];
    return pageName ? pageName : "不明なページ"
}